const a = "stash-menus-mount-node", m = {
  install(u, e) {
    const t = (e == null ? void 0 : e.mountNodeId) || a;
    let d = document.getElementById(t);
    d || (d = document.createElement("div"), d.id = t, d.dataset.test = a, e != null && e.mountNodeClass && d.classList.add(e.mountNodeClass), document.body.appendChild(d));
  }
};
export {
  a as D,
  m as M
};
//# sourceMappingURL=MenusPlugin-Bk6UW6o9.js.map
